/**
 * @ngdoc directive
 * @name mission
 *
 * @description
 * Mission panel
 */
module.directive('mission', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '=',
            index: '@'
        },
        controller: ['$scope', function ($scope) {
            $scope.buttonLabel = 'Faire un don';

            $scope.isMissionOpen = false;

            $scope.toggleMission = function () {
                $scope.isMissionOpen = !$scope.isMissionOpen;
            };
        }],
        template:
                '<div class="aqua-mission grid grid-v" ng-class="{\'aqua-mission--alternate\':index % 2 === 1}">' +

                /* mission title (accordion button) */
                '  <div class="aqua-mission--header grid-12">' +
                '    <h2 class="aqua-mission--category grid {{content.field_program | lowercase}}" ng-click="toggleMission()" ng-class="{\'is-open\':isMissionOpen}"><span class="aqua-mission--category-text">{{content.field_program}}</span></h2>' +
                '  </div>' +

                /* mission presentation section */
                '  <div class="aqua-mission--body grid-12 grid">' +
                '    <div class="aqua-mission--figure grid-12-s">' +
                '      <img class="aqua-mission--picture" aqua-src="{{content.field_image.src}}" alt="{{content.field_image.alt}}">' +
                '    </div>' +
                '    <div class="aqua-mission--description grid-12-s grid grid-v">' +
                '      <h3 class="aqua-mission--title">{{content.title}}</h3>' +
                '      <p class="aqua-mission--chapo">{{content.field_teaser}}</p>' +
                '    </div>' +
                '  </div>' +

                /* picture & donation information section */
                '  <div class="aqua-mission--footer grid-12 grid grid-r" ng-show="isMissionOpen">' +
                '    <div class="aqua-mission--subdescription grid-12-s">' +
                '      <div class="aqua-mission--content aqua-richtext" ng-bind-html="content.body | trustAsHtml"></div>' +
                '    </div>' +
                '    <div class="aqua-mission--donate grid-12-s">' +
                '      <h3 class="aqua-mission--donate-title">Objectif : <span class="aqua-mission--donate-goal">{{content.field_goal}}</span></h3>' +
                '      <p class="aqua-mission--argument">{{content.field_pitch}}</p>' +
                '      <button class="aqua-mission--button grid-12-s" ui-sref="donation({program:\'{{content.field_program | lowercase}}\'})">{{buttonLabel}}</button>' +
                '    </div>' +
                '  </div>' +

                '</div>'
    };
});
